import type { LedgerDirection, SalesLedgerTransactionType } from "../Types";

export interface SalesLedgerTypeMeta {
  value: SalesLedgerTransactionType;
  label: string;
  tagColor: string;
  direction: LedgerDirection;
}

export const SALES_LEDGER_TYPES: SalesLedgerTypeMeta[] = [
  {
    value: "sales",
    label: "Complete Sale",
    tagColor: "success",
    direction: "inflow",
  },
  {
    value: "credit_sales",
    label: "Credit Sale",
    tagColor: "warning",
    direction: "inflow",
  },
  {
    value: "credit_payments",
    label: "Credit Payment",
    tagColor: "processing",
    direction: "inflow",
  },
  {
    value: "services",
    label: "Other Income",
    tagColor: "cyan",
    direction: "inflow",
  },
  {
    value: "returns",
    label: "Customer Return",
    tagColor: "error",
    direction: "outflow",
  },
  {
    value: "expenses",
    label: "Expense",
    tagColor: "red",
    direction: "outflow",
  },
];

export const SALES_LEDGER_DEFAULT_TYPES: SalesLedgerTransactionType[] =
  SALES_LEDGER_TYPES.map((type) => type.value);

export const SALES_LEDGER_TYPE_MAP = Object.fromEntries(
  SALES_LEDGER_TYPES.map((type) => [type.value, type]),
) as Record<SalesLedgerTransactionType, SalesLedgerTypeMeta>;
